export const noSubject = "Lj0Ihc";
export default {noSubject};